<template>
    <div class="verification-code mt-5">
        <h5>Verification Code</h5>
        <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            separator=""
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-complete="handleOnComplete"
        />
        <p v-if="wrongCode" class="error-text mt-2 mb-0">Wrong verification code</p>
        <button @click="confirm" class="activation-btn mb-3" :disabled="!code">
            Confirm Activation Code
        </button>
        <div class="actions">
            <p class="mb-0 mt-1">Sent to the wrong email? <span class="c1" @click="goBack">Go back</span> </p>
            <p class="mt-1">Didn't receive the message? <span class="c1" @click="sendEmail">Send again</span> </p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import OtpInput from "@bachdgvn/vue-otp-input";
import {validationUtils} from '../../../core/utils'
import {ref, computed} from '@vue/composition-api'
Vue.component("v-otp-input", OtpInput);
import useCode from './useCode'
import {message} from 'ant-design-vue'

export default {
    name: 'ConfirmCode',
    components: {
        OtpInput
    },
    props: {
        emailCode: String,
        email: String
    },
    setup(props, {emit}){

        const {
            code, 
            setCode, 
            confirmCode,
            wrongCode
        } = useCode()

        const optInput = ref()

        const handleOnComplete = value => {
            setCode(validationUtils.isNumber(value) ? value : null)
        }

        const goBack = () => {
            setCode(null)
            emit('setEmailCode', null)
            emit('setEmail', props.email)
        }
        const confirm = () => {
            const result = confirmCode(props.emailCode)
            if(result) {
                emit('saveData')
            }
        }

        const sendEmail = () => {
            message.success('Confirmatin code sent again.')
            emit('sendEmail')
        }


        return {
            code,
            handleOnComplete,
            confirm,
            optInput,
            goBack,
            wrongCode,
            sendEmail
        }
    }
}
</script>

<style lang="scss">
  .otp-input {
    width: 48px;
    height: 48px;
    padding: 5px;
    margin: 0 6px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid #CBD5E0;
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }

    &:focus {
        border: 1px solid blue;
    }

    &:invalid {
      border: 1px solid red !important;
    }

    // &:required:invalid {
    //   border: 1px solid yellow !important;
    // }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>


<style lang="scss" scoped>
    .verification-code {
        border: 1px solid #CBD5E0;
        padding: 24px;
        border-radius: 4px;
        h5 {
            font-size: 18px;
            margin-bottom: 24px;
            font-weight: 500;
            color: #111111
        }

        .activation-btn {
            margin-top: 24px;
            padding: 8px 20px;
            background: #0ACF97 !important;
            border-radius: 5px;
            color: #FFFFFF;
            transition: all 0.1s linear;

            &:hover {
                box-shadow: 0px 4px 10px rgba(10, 207, 151, 0.39);
                border: 0 !important;
                outline: 0 !important;
            }

            &:disabled {
                opacity: 0.4
            }
        }

        .actions p {
            cursor: pointer
        }
    }

</style>